var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 1.21875C15.0625 1.53125 15.0625 2 14.7812 2.28125L6.53125 10.5312C6.21875 10.8438 5.75 10.8438 5.46875 10.5312L1.21875 6.28125C0.90625 6 0.90625 5.53125 1.21875 5.25C1.5 4.9375 1.96875 4.9375 2.25 5.25L5.96875 8.96875L13.7188 1.21875C14 0.9375 14.4688 0.9375 14.75 1.21875H14.7812Z",
    fill: "#00789E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.38dfcc8db4bc58342ba49e144d59aec0.svg";
export { ForwardRef as ReactComponent };